import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import { verifyPhone ,verifyRegisterPhone,getVerifyCode,syncAccount,getCrsDetail, invitationCode, realUserMobileCaptcha} from '../../action/investmentAction';
import { getCapcha,getMobileCaptcha } from '../../action/loginAction.js';
import Util from '../../util.js';
import { getTempInfo} from '../../common.js';
import NavigatorMain from '../NavigatorMain';
import { myPhoneNum,myVerifyCode} from '../../action/publicAction';
import {protocolCode } from '../../BankCode'
import './css/BindingMobile.css';
import Loading from '../../Loading.js'
import { goHome } from '../../common.js';
class BindingMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRequestingVerifyCode: false,
      countDown: 120,
      loading: false,
      setModalShow: false,
      agreeIndex:0,
      invitationCode: this.props.location.query.invitationCode ? this.props.location.query.invitationCode : "",
      invitationCodeFlag: false,
      enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
      serverCapchaCode: '',
      imageBase64: '',
      VerificationCode:''
    };
    this.intervalId = null;
    this.requestId = '';
    this.PopDid = false;
    this.goCallback=false;
  }
  componentWillMount(){
    Loading.hide();
    document.title = "一键开户"
    this.setState({
      phoneNum:this.props.mobileNo
    })
    this.props.dispatch(getCapcha((code, imageBase64)=>{console.log('1&&&&&&&&&&'); this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));

  }
  getCapchaCodeSuccess(code, imageBase64){
    console.log('verifySuccess');
    this.setState({
      serverCapchaCode: code,
      imageBase64,
      getCapchaSuccess:true
     
    });
  }
  getCapchaCodeAgain(){
    this.setState({
      VerificationCode:''
    })
    this.props.dispatch(getCapcha((code,imageBase64)=>{this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
  }
  getCapchaCodeError(msg){
    Toast.info(msg, Util.ToastTime );
    this.setState({getCapchaSuccess: false});
  }
  onChangeText(e){
    this.props.dispatch(myPhoneNum(e.target.value))
    // this.setState({
    //   phoneNum:e.target.value
    // })
  }
  handleWaitingForVC(){
    if(!(/^1[0123456789]\d{9}$/.test(this.props.phoneNum))){
      Toast.info('请输入正确的手机号码', Util.ToastTime);
      return ;
    }
    // this.requestId = '';
    this.props.dispatch(verifyRegisterPhone({mobileNo: this.props.phoneNum}, (phoneNum)=>{this.verifyRegisterPhoneSuc(phoneNum)}, (msg)=>{this.verifyRegisterPhoneErr(msg)}));
    
  }
  componentWillUnmount(){
    clearInterval(this.intervalId);
    if (this.goCallback) {
      this.props.location.state.callback ? this.props.location.state.callback() : null
    }
  }
  verifyRegisterPhoneSuc(phoneNum){
    let {serverCapchaCode,VerificationCode } = this.state;
    if(VerificationCode){
      let params = { mobileNo: phoneNum,
        token: serverCapchaCode,
        captchaCode: VerificationCode.toUpperCase()
       }
      this.props.dispatch(getMobileCaptcha(params,(requestId)=>{this.getMobileCaptchaSucc(requestId)},(succ)=>{this.getMobileCaptchaErr(succ)}));
    }else{
      Toast.info('请输入图形验证码', Util.ToastTime);
    }

    // this.props.dispatch(realUserMobileCaptcha(params, (requestId)=>{this.requestId = requestId; console.log(requestId)}));
  }
  verifyRegisterPhoneErr(msg){
    Toast.info(msg, Util.ToastTime);
    if(this.intervalId)
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.setState({
              isRequestingVerifyCode: false
      });
  }
  getMobileCaptchaSucc(requestId){
    this.requestId = requestId; 
    console.log(requestId)
    let countNum = 119;
    this.setState({isRequestingVerifyCode: true, countDown: countNum}, ()=>{
      this.intervalId = setInterval(() => {
        countNum--;
        // console.log(countNum);
        if(countNum < 0){
          this.getCapchaCodeAgain();
          cancelTimeOut();
          this.setState({
            isRequestingVerifyCode: false
          });
        }
        this.setState({
          countDown: countNum
        })
      }, 1000);
      const cancelTimeOut = () => {
        if(this.intervalId)
          clearInterval(this.intervalId);
        this.intervalId = null;
      }
    });
  }
  getMobileCaptchaErr(succ){
    Toast.show(succ.message, Util.ToastTime);
    this.getCapchaCodeAgain();
  }
  Verification(e){
    this.props.dispatch(myVerifyCode(e.target.value))
    // this.setState({
    //   verifyCode:e.target.value
    // })
  }
  async handleVerify(){
    if(!this.props.verifyCode || !this.props.phoneNum){
      Toast.info('请输入信息', Util.ToastTime );
      return;
    }
    if(!(/^1[0123456789]\d{9}$/.test(this.props.phoneNum))){
      Toast.info('请输入正确的手机号码', Util.ToastTime );
      return ;
    }
    if(!this.state.VerificationCode){
      Toast.info('请输入图形验证码', Util.ToastTime);
      return ;
    }
    if(this.requestId === '' || !this.requestId){
      Toast.info('请先申请手机验证码', Util.ToastTime );
      return ;
    }
    if(this.state.invitationCode && !(/^1[0123456789]\d{9}$/.test(this.state.invitationCode))){
      Toast.info('用户邀请码不合规', Util.ToastTime );
      return ;
    }
    // if(this.state.invitationCode == this.props.phoneNum){
    //   Toast.info('用户邀请码不能与开户的手机号一致', 2);
    //   return ;
    // }
    let verifyParam = {
      requestId : this.requestId,
      mobileNo : this.props.phoneNum,
      captcha : this.props.verifyCode,
      token: await getTempInfo('shortToken')
    }
    console.log(verifyParam);
    console.log('verify');
    this.setState({
      loading: true
    })
    this.props.dispatch(verifyPhone(verifyParam, ()=>{sessionStorage.setItem('sync',`${ this.props.phoneNum},${ this.requestId},${ this.state.invitationCode ? this.state.invitationCode : ""}`);this.verifySuccess()}, (msg)=>this.verifyError(msg)));
  }
  verifySuccess(){

    this.props.dispatch(getCrsDetail((content)=>{this.crsSuc(content)},(msg)=>{this.crsErr(msg)}))
  }
  crsSuc(content){
    // var content={"tradeAccountNo":"40000401984","name":"张广文","certType":"0","certNo":"120110198102083022","email":"zhgw@buaa.edu.cn","sex":"0","address":"北京市海淀区学院路37号北航公共管理学院","birthday":350409600000,"isExpert":false,"residentType":0,"crsAccountInfo":{}}
    if (content.residentType!=null&&content.isAbroad!=null) {
      this.props.dispatch(syncAccount( {isAbroad:content.isAbroad,residentType:content.residentType,provinceUs:content.crsAccountInfo.provinceUs,cityUs:content.crsAccountInfo.cityUs,postCode:content.crsAccountInfo.postCode,email:content.crsAccountInfo.email,provinceZh:content.crsAccountInfo.provinceZh,cityZh:content.crsAccountInfo.cityZh,birthCityUs:content.crsAccountInfo.birthCityUs,birthCityZh:content.crsAccountInfo.birthCityZh},(resInfo)=>{
        if (this.props.location.state.route) {
          if(this.state.enterType){
            if(this.state.enterType=='SubscriptionDetail'){
              this.goCallback=true;
              hashHistory.go(-1);
            }else if(this.state.enterType ==="Answer"){
              console.log("进入答题")
              hashHistory.push({
                pathname:'/AnswerActivityDatillPage',
                state:{},
                query: {enterType:"Answer", activityId:this.props.location.query.activityId}
              })
            }else if(this.state.enterType == "activity"){
              let userId_a = resInfo.userId ? resInfo.userId :"";
              let tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
              let paramsStr = "userId=" +  userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
              console.log(paramsStr)
              let paramsData = window.encodeURIComponent(Util.aesEncrypt(paramsStr));
              window.location.href = Util.hdUrl + paramsData
            }else{
              hashHistory.replace({
                 pathname:'/?enterType="Investment' ,
              })
            }
          }else{
            this.goCallback=true;
            hashHistory.go(-1)
          }
        }else{
          if(this.state.enterType){
            if(this.state.enterType=='SubscriptionDetail'){
              this.goCallback=true;
              hashHistory.go(-1);
            }else if(this.state.enterType ==="Answer"){
              console.log("进入答题")
              hashHistory.push({
                pathname:'/AnswerActivityDatillPage',
                state:{},
                query: {enterType:"Answer", activityId:this.props.location.query.activityId}
              })
            }else if(this.state.enterType == "activity"){
              let userId_a = resInfo.userId ? resInfo.userId :"";
              let tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
              let paramsStr = "userId=" +  userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
              console.log(paramsStr)
              let paramsData = window.encodeURIComponent(Util.aesEncrypt(paramsStr));
              window.location.href = Util.hdUrl + paramsData
            }else{
              hashHistory.replace({
                 pathname:'/?enterType="Investment' ,
              })
            }
          }
        }
      },(msg)=>{
        Toast.info(msg, Util.ToastTime);
      }))
    }else{
      console.log('4')
      hashHistory.push({
        pathname:'/TaxInfo',
        query:{
          enterType:this.state.enterType,
          activityId:this.props.location.query.activityId
        },
        state:{callback:this.props.location.state.callback,route:this.props.location.state.route}
      })
    }
  }
  crsErr(msg){
    Toast.info(msg, Util.ToastTime);
  }
  verifyError(msg){
    Toast.info(msg, Util.ToastTime);
  }
  clear(){
    this.props.dispatch(myPhoneNum(''));
  }
  goBack(){
    this.props.dispatch(myPhoneNum(''));
    this.props.dispatch(myVerifyCode(''));
    hashHistory.goBack()
  }
  ProtocolPaper(name){
    let code=protocolCode[name];
    console.log(hashHistory)
    hashHistory.push({
        pathname:'/WebView',
        state:{name:name,code:code},
        query: {code:code}
    })
  }
  isAgreeClick(){
    let { agreeIndex } =this.state;
    if (agreeIndex===0) {
      this.setState({
        agreeIndex:1
      })
    } else {
      this.setState({
        agreeIndex:0,
      })
    }
  }
  toggleInvitation = () => {
    this.setState({
      invitationCodeFlag: !this.state.invitationCodeFlag
    });
  }
  changeIncode = (event) => {
    this.setState({
      invitationCode: event.target.value
    });
    this.props.dispatch(invitationCode(event.target.value));
  }
  render(){
    console.log(hashHistory.location)
    const img_arr = [require('../../img/square.png'),require('../../img/protocol_selected.png')];
    return (
        <div className="container" >
        <NavigatorMain>
          <div className="BindingMobile-header">
            <div onClick={()=>this.goBack()}><span className="headerLeftBtn"></span></div>
            <div>一键开户</div>
            <div></div>
          </div>
        </NavigatorMain>
        <div className='content'>
           <div className='sync-header'>
                华夏查理智投是由华夏基金全资子公司华夏财富为您提供的，您需要同步账户信息并开通华夏财富账户。为了您的账户安全，请绑定常用手机号：
            </div>
            <div className='BindingMobile-input-box' >
              <p >手机号</p>
              <input autocomplete="off"  onChange={(e)=>this.onChangeText(e)} type="text" value={this.props.phoneNum} placeholder={'请输入手机号'} />
              <img onClick={()=>this.clear()} src={require('../../img/login_input_cancel.png')} className='imgBtn'  />
            </div>

            <div className="BindingMobile-input-box">
                    <p >图形验证码</p>
                    <input autocomplete="off" type="text" value={ this.state.VerificationCode } onChange={ (e) =>{ this.setState({ VerificationCode: e.target.value})}}  placeholder={'请输入图形验证码'} />
                    <p style={{display: "-webkit-flex", WebkitAlignItems: "center",}}onClick = {()=>{this.getCapchaCodeAgain()}}>
                      <img style={{
                        width: 63,
                        height: 27,
                      }} src={`data:image/png;base64,${this.state.imageBase64}`} />
                    </p>
            </div>
            <div className='BindingMobile-input-box'>
              <p >手机动态码</p>
              <input autocomplete="off"  onChange={(e)=>this.Verification(e)} type="text" value={this.props.verifyCode} placeholder={'请输入短信验证码'} />
              {
                this.state.isRequestingVerifyCode ? <p className='BindingMobile-input-yzm'>{this.state.countDown}秒后重发</p>:
              <p className='BindingMobile-input-yzm' onClick={()=>this.handleWaitingForVC()}>获取验证码</p>
              }
            </div>

            <div style={{height: 45, paddingRight: 13, paddingLeft: 13}}>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitJustifyContent: "flex-end", WebkitFlexDirection: "row", height: "100%"}}>
                <div style={{width: 120}}>
                  <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "flex-end"}} onClick={this.toggleInvitation}>
                    <span style = {{color: '#3a3e47', marginLeft: 13, fontSize: 13}}>我有邀请码</span>
                    {
                      this.state.invitationCodeFlag ?
                      <img style={{width: 30, height: 30}} src={require('../../img/arrowBm2@4x.png')} />
                      :
                      <img style={{width: 30, height: 30}} src={require('../../img/arrowBm@4x.png')} />
                    }
                  </div>
                </div>
              </div>
            </div>
            {
              this.state.invitationCodeFlag ?
              <div style = {{
                width:'auto',
                height: 45,
                borderBottom: '1px solid rgba(242,245,247,1)',
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              }}>
                <span style = {{color: '#3a3e47', marginLeft: 13, fontSize: 13, width: 80}}>邀请码</span>
                <div style = {{
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1,
                  display: "-webkit-flex"
                }}>
                  <input autocomplete="off" type="text" style = {{WebkitFlex: 1, fontSize: 13, display: "-webkit-flex"}} placeholder = {'输入推荐人手机号码'} value = {this.state.invitationCode} onChange = {this.changeIncode}/>
                  <div onClick = {()=>{this.setState({invitationCode: ''}); this.props.dispatch(invitationCode(""));}}>
                    <img style={{marginRight: -2, width: 44, height: 44}} src={require('../../img/login_input_cancel.png')} />
                  </div>
                </div>
              </div>
              :
              null
            }
            <div className='BindingMobile-xy-box'>
              <img src={img_arr[this.state.agreeIndex]} className='imgBtn' onClick={()=>this.isAgreeClick()}/>
              <p >我已阅读并同意<span className='red-t' onClick={()=>this.ProtocolPaper('华夏财富同步信息快捷开户协议书')}>《华夏财富同步信息快捷开户协议书》</span>和<span className='red-t' onClick={()=>this.ProtocolPaper('华夏财富电子交易服务协议')}>《华夏财富电子交易服务协议》</span></p>
            </div>
            {this.props.phoneNum&&this.props.verifyCode&&this.state.agreeIndex==1?<div onClick={()=>this.handleVerify()} className='yjkh-btn yjkh-btn2'>
              一键开户
              </div>:<div  className='yjkh-btn'>
              一键开户
              </div>
            }
            <div className='yjkh-tip'>
              <div >特别提醒 :</div>
              <p >
                开通华夏财富账户后，登录密码和交易密码与华夏基金当前的交易密码一致。如有需要，您可以登录华夏财富APP或官网，修改登录和交易密码。
              </p>
            </div>
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    mobileNo:state.mobileNo,
    phoneNum:state.phoneNum,
    verifyCode:state.verifyCode
  }
}
export default connect(mapStateToProps)(BindingMobile);



// WEBPACK FOOTER //
// ./src/components/sync/BindingMobile.js